export type Gender = 'male' | 'female' | 'other' | 'null';

export enum Genders {
  MALE = 'male',
  FEMALE = 'female',
  OTHER = 'other',
  NULL = 'null',
}
